import "./Footer.scss";
import { PUBLIC_URL } from "../../configs/main";
import { getDomainConfig } from "../../configs/main";

export default function Footer() {
    const handleClick = () => {
        if (getDomainConfig().brand === 'retargeo') {
            window.open(`${PUBLIC_URL}/retargeo_docs/publichnyj_dogovor-oferta.pdf`);
        } else {
        window.open(`${PUBLIC_URL}/publichnyj_dogovor-oferta.docx`);
        }
    };
    return (
        <div className="footer-container">
            <div>Ⓒ {getDomainConfig().brand === 'programmatic' ? `2022-${new Date().getFullYear()}` : `2025-${new Date().getFullYear()}`} {getDomainConfig().title}</div>
            <div className="oferta" style={{ gap: '5px' }}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '5px' }}>
                    {getDomainConfig().brand === 'programmatic' ? (
                        <>
                            <button onClick={() => window.open(`https://programmatic.ru/oferta/`)}>Оферта</button>
                            <button onClick={() => window.open(`https://programmatic.ru/politika_konfidencialnosti/`)}>Политика конфиденциальности</button>
                            <button onClick={() => window.open(`https://programmatic.ru/pravila_polzovaniya_sajtom/`)}>Правила пользования сайтом</button>
                            <button onClick={() => window.open(`https://programmatic.ru/pravila_razmeshcheniya_reklamnyh_obyavlenij/`)}>Правила размещения рекламных объявлений</button>
                            <button onClick={() => window.open(`https://programmatic.ru/soglasie_na_obrabotku_personalnyh_dannyh/`)}>Согласие на обработку персональных данных</button>
                        </>
                    ) : (
                        <button onClick={handleClick}>Оферта</button>
                    )}
                </div>
                <div>
                    {getDomainConfig().brand === 'programmatic' ? 'info@programmatic.ru' : 'techsupport@retargeo.ru'}
                </div>
            </div>
        </div>
    );
}
